import request from "@utils/request";

//***********蛋糕叔叔************

// 入口地址
export function dgLoginCodeSign(data){
    return request.get("/dgLoginSignkj",data)
}

// 卡劵入口地址
export function dgLoginSign(data){
    return request.get("/dgLoginSign",data)
}

// 订单详情
export function orderDgPaying(data,id){
    return request.post(`/order/dgPaying&order_no=${data}&uid=${id}`,{login:false})
}

/*PR
 * 支付
 * */
export function orderOrderPayResult(order_id, paytype, from, coupon_id=null){
    return request.post("/order/orderPayResult", { order_id, paytype, from, coupon_id });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(type,types) {
    return request.get("/coupons/user/" + type+'/'+types,{}, {login: false});
}

/*
订单列表
*/
export function CakeOrderList (data){
    return request.get("/order/dgList",data)
}

/**
 * 获取订单列表 全部/待付款/已完成
 * @param {*} data 
 */
export function getdgOrderStatus () {
    return request.get("/order/dgData");
}

/*
*订单详情
*/

export function orderDgDetail(id){
return request.get(`/order/dgDetail/${id}`)
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function dgExpress(uni) {
    // return request.get("order/express/" + uni);
    return request.get("/order/dgExpress",{uni});
  }

  /****
   * 
   * 蛋糕叔叔虚拟商品 订单详情
   */

  export function dgkjPaying(data,id){
return request.post(`/order/dgkjPaying&order_no=${data}&uid=${id}`,{login:false})
  }

  /*PR
 * 支付
 * */
export function orderDgPayment(order_id, paytype, from, coupon_id=null){
    return request.post("/order/orderkjPayResult", { order_id, paytype, from, coupon_id });
}

/*
*蛋糕叔叔卡劵订单详情
*/

export function orderDgCodeDetail(id){
    return request.get(`/order/dgkjDetail/${id}`)
    }